import { render } from "./InformeTrabajosNoLiquidados.vue?vue&type=template&id=37d1851c&scoped=true"
import script from "./InformeTrabajosNoLiquidados.vue?vue&type=script&lang=js"
export * from "./InformeTrabajosNoLiquidados.vue?vue&type=script&lang=js"

import "./InformeTrabajosNoLiquidados.vue?vue&type=style&index=0&id=37d1851c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d1851c"]])

export default __exports__